<template>
  <a-card :bordered="false">
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />批量删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :scroll="{ x: 1600 }"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record.id)">删除</a>
        </span>
      </a-table>
    </div>

    <a-drawer
      :title="title"
      :visible="visible"
      :width="900"
      :maskClosable="true"
      placement="right"
      @close="handleCancel"
    >
      <a-spin :spinning="confirmLoading">
        <a-form
          :form="form"
          class="rate-form"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-form-item label="产品名称" required>
            <a-input
              placeholder="请输入产品名称"
              disabled
              v-model="fundInfo.fundName"
            ></a-input>
          </a-form-item>
          <a-form-item label="起始日">
            <a-date-picker
              style="width: 100%"
              v-decorator="[
                'startTime',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择起始日!'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="披露类型">
            <a-select
              placeholder="请选择"
              v-decorator="[
                'releaseType',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择披露类型!'
                    }
                  ]
                }
              ]"
              @change="val => selectChange(val, 'release')"
            >
              <a-select-option
                v-for="item in releaseTypeData"
                :value="item.value"
                :key="item.value"
              >
                {{ item.name }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item
            :label="releaseLabel"
            v-if="releaseType != 5 && releaseType != 0"
          >
            <a-select
              v-if="releaseType != 4"
              @change="handleSelectChange"
              v-decorator="['releaseDay']"
              placeholder="请选择"
            >
              <a-select-option
                v-for="item in releaseTypeList"
                :value="item.value"
                :key="item.id"
              >
                {{ item.name }}</a-select-option
              >
            </a-select>

            <a-date-picker
              v-if="releaseType == 4"
              style="width: 100%"
              v-decorator="[
                'releaseDate',
                {
                  rules: [
                    {
                      required: true,
                      message: ''
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label=" " :colon="false">
            <a-checkbox
              v-decorator="[
                'isjyr',
                { initValue: false, valuePropName: 'checked' }
              ]"
            >
              是否交易日（披露）
            </a-checkbox>
          </a-form-item>
          <a-form-item label="发布类型">
            <a-select
              v-decorator="[
                'publishType',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择发布类型!'
                    }
                  ]
                }
              ]"
              placeholder="请选择"
              @change="val => selectChange(val, 'publish')"
            >
              <a-select-option
                v-for="item in publishTypeData"
                :value="item.value"
                :key="item.value"
              >
                {{ item.name }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item
            :label="publishLabel"
            v-if="publishType != 5 && publishType != 0"
          >
            <a-select
              v-if="publishType != 4"
              v-decorator="[
                'publishDay',
                {
                  rules: [
                    {
                      required: true,
                      message: ''
                    }
                  ]
                }
              ]"
              placeholder="请选择"
            >
              <a-select-option
                v-for="item in publishTypeList"
                :value="item.value"
                :key="item.value"
              >
                {{ item.name }}</a-select-option
              >
            </a-select>
            <a-date-picker
              v-if="publishType == 4"
              style="width: 100%"
              v-decorator="[
                'publishDate',
                {
                  rules: [
                    {
                      required: true,
                      message: ''
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label=" " :colon="false">
            <a-checkbox
              v-decorator="[
                'publishIsjyr',
                { initValue: false, valuePropName: 'checked' }
              ]"
            >
              是否交易日（发布）
            </a-checkbox>
          </a-form-item>
          <a-form-item label="净值日期控制">
            <a-select
              v-decorator="[
                'publishNavBefore',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择'
                    }
                  ]
                }
              ]"
              placeholder="请选择"
            >
              <a-select-option
                v-for="item in netWorthData"
                :value="item.value"
                :key="item.value"
              >
                {{ item.name }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
      <div class="drawer-bootom-button">
        <a-popconfirm
          title="确定放弃编辑？"
          @confirm="handleCancel"
          okText="确定"
          cancelText="取消"
        >
          <a-button style="margin-right: 0.8rem">取消</a-button>
        </a-popconfirm>
        <a-button @click="handleOk" type="primary">提交</a-button>
      </div>
    </a-drawer>
  </a-card>
</template>

<script>
const columns = [
  {
    title: '披露类型',
    dataIndex: 'releaseType',
    align: 'center',
    width: 200,
    customRender: text => {
      if (text == 0) {
        return '按日定期披露';
      } else if (text == 1) {
        return '按周定期披露';
      } else if (text == 2) {
        return '按月定期披露';
      } else if (text == 3) {
        return '按季定期披露';
      } else if (text == 4) {
        return '按年定期披露';
      } else if (text == 5) {
        return '按开放日定期披露';
      } else if (text == 6) {
        return '发布开放日放日';
      }
    }
  },
  {
    title: '发布起始日',
    dataIndex: 'startTime',
    align: 'center',
    width: 200
  },
  {
    title: '是否交易日(发布)',
    dataIndex: 'publishIsjyr',
    align: 'center',
    width: 200,
    customRender: text => {
      return text == 0 ? '否' : '是';
    }
  },
  {
    title: '净值日期控制',
    dataIndex: 'publishNavBefore_txt',
    align: 'center',
    width: 200
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    align: 'center',
    width: 200
  },
  {
    title: '发布类型',
    dataIndex: 'publishType',
    align: 'center',
    width: 200,
    customRender: text => {
      if (text == 0) {
        return '按日定期发布';
      } else if (text == 1) {
        return '按周定期发布';
      } else if (text == 2) {
        return '按月定期发布';
      } else if (text == 3) {
        return '按季定期发布';
      } else if (text == 4) {
        return '按年定期发布';
      } else if (text == 5) {
        return '按开放日定期发布';
      } else if (text == 6) {
        return '开放日当日披露';
      }
    }
  },
  {
    title: '是否交易日',
    dataIndex: 'isjyr',
    align: 'center',
    width: 200,
    customRender: text => {
      return text == 0 ? '否' : '是';
    }
  },
  // {
  //   title: '发布日',
  //   dataIndex: 'startTime',
  //   align: 'center',
  //   width: 200
  // },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    width: 200,
    fixed: 'right',
    scopedSlots: { customRender: 'action' }
  }
];
import { initRateRules, saveRateRules } from '@/api/product';
import { postTag } from '@/api/manage';
import moment from 'moment';
export default {
  data() {
    return {
      columns,
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      loading: false,
      selectedRowKeys: [],
      title: '新增',
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      releaseTypeData: [],
      publishTypeData: [],
      netWorthData: [],
      releaseTypeList: [],
      publishTypeList: [],
      releaseLabel: '',
      publishLabel: '',
      releaseType: '',
      publishType: '',
      fundInfo: {},
      delete: process.env.VUE_APP_CMS_PRODUCT + '/product/value/rule/del',
      deleteBatch:
        process.env.VUE_APP_CMS_PRODUCT + '/product/value/rule/delBatch'
    };
  },
  created() {
    this.initList();
    this.initSelectData();
    this.initValue();
    this.initType();
    this.fundInfo = JSON.parse(sessionStorage.getItem('productParticulars'));
  },
  methods: {
    moment,
    handleSelectChange(value) {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          releaseDay: value
        });
      });
    },
    //初始化下拉框的值
    initSelectData() {
      this.netWorthData = [];
      for (let i = 0; i < 8; i++) {
        this.netWorthData.push({
          value: i,
          name: i > 0 ? 'T' + i : 'T'
        });
      }
    },
    initValue(number, flg, val) {
      let length = number ? number : 8;
      console.warn(length);
      let str = val ? val : '日';
      if (!flg) {
        for (let i = 1; i < length; i++) {
          this.releaseTypeList.push({
            value: i,
            name: '第' + i + str
          });
          this.publishTypeList.push({
            value: i,
            name: '第' + i + str
          });
        }
        this.releaseTypeList.push({
          value: 99,
          name: '最后一' + str
        });
        this.publishTypeList.push({
          value: 99,
          name: '最后一' + str
        });
      } else {
        if (val == '季度') {
          for (let i = 1; i <= 3; i++) {
            for (let j = 1; j < 32; j++) {
              let dis = i + '-';
              if (flg == 'release') {
                this.releaseTypeList.push({
                  value: j > 10 ? dis + j : dis + '0' + j,
                  name: '第' + i + '个月' + '第' + j + '日'
                });
              } else {
                this.publishTypeList.push({
                  value: j > 10 ? dis + j : dis + '0' + j,
                  name: '第' + i + '个月' + '第' + j + '日'
                });
              }
            }
          }
        } else {
          for (let i = 1; i < length; i++) {
            if (flg == 'release') {
              this.releaseTypeList.push({
                value: val == '天' ? (i > 10 ? i : '0' + i) : i,
                name: '第' + i + str
              });
            } else {
              this.publishTypeList.push({
                value: val == '天' ? (i > 10 ? i : '0' + i) : i,
                name: '第' + i + str
              });
            }
          }
          this.releaseTypeList.push({
            value: 99,
            name: '最后一' + str
          });
          this.publishTypeList.push({
            value: 99,
            name: '最后一' + str
          });
        }
      }
    },
    initList() {
      let params = {
        fundCode: this.$route.query.fundCode,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        isDelete: 0
      };
      initRateRules(params).then(res => {
        if (res.success) {
          this.dataSource =
            res.result && res.result.records ? res.result.records : [];

          if (this.dataSource.length > 0) {
            this.dataSource.forEach(item => {
              let obj = this.netWorthData.find(
                ele => ele.value == item.publishNavBefore
              );
              item.publishNavBefore_txt = obj.name;
            });
          }
          this.ipagination.total = res.result.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    initType() {
      this.releaseTypeData = [
        {
          value: 0,
          name: '按日定期披露'
        },
        {
          value: 1,
          name: '按周定期披露'
        },
        {
          value: 2,
          name: '按月定期披露'
        },
        {
          value: 3,
          name: '按季定期披露'
        },
        {
          value: 4,
          name: '按年定期披露'
        },
        {
          value: 5,
          name: '按开放日定期披露'
        },
        {
          value: 6,
          name: '开放日当日披露'
        }
      ];
      this.publishTypeData = [
        {
          value: 0,
          name: '按日定期发布'
        },
        {
          value: 1,
          name: '按周定期发布'
        },
        {
          value: 2,
          name: '按月定期发布'
        },
        {
          value: 3,
          name: '按季定期发布'
        },
        {
          value: 4,
          name: '按年定期发布'
        },
        {
          value: 5,
          name: '按开放日定期发布'
        },
        {
          value: 6,
          name: '披露开放日当日净值'
        }
      ];
    },
    //披露类型变化
    selectChange(val, flg) {
      this[flg + 'Type'] = val;
      this[flg + 'Label'] = this[flg + 'TypeData'][val].name;
      switch (val) {
        case 0:
          break;
        case 1:
          this[flg + 'TypeList'] = [];
          this.initValue(8, flg, '日');
        case 2:
          this[flg + 'TypeList'] = [];
          this.initValue(32, flg, '天');
          break;
        case 3:
          this[flg + 'TypeList'] = [];
          this.initValue(32, flg, '季度');
          break;
        case 4:
          break;
        case 5:
          break;
        case 6:
          if (flg == 'release') {
            this.releaseTypeList = [{ value: null, name: '开放日当日' }];
          } else {
            this.publishTypeList = [{ value: 0, name: '开放日次日或之后' }];
          }
          break;
        default:
          break;
      }
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      // this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log(selectionRows);
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initList();
    },
    handleAdd() {
      this.form.resetFields();
      this.currentItem = {};
      this.visible = !this.visible;
    },
    handleEdit(record) {
      this.visible = true;
      this.currentItem = record;
      this.$nextTick(() => {
        this.form.resetFields();
        this.form.setFieldsValue({
          ...record,
          releaseType: parseInt(record.releaseType),
          startTime: moment(record.startTime),
          isjyr: record.isjyr == 0 ? false : true,
          publishIsjyr: record.publishIsjyr == 0 ? false : true
        });
      });
    },
    handleCancel() {
      this.visible = !this.visible;
      this.form.resetFields();
    },
    handleOk() {
      console.warn(this.form.validateFields);
      this.form.validateFields((error, values) => {
        if (!error) {
          let params = {
            ...values,
            fundCode: this.$route.query.fundCode,
            isjyr: values.isjyr ? 1 : 0,
            publishIsjyr: values.publishIsjyr ? 1 : 0,
            startTime: moment(values.startTime).format('YYYY-MM-DD')
          };
          if (this.currentItem.id) {
            params.id = this.currentItem.id;
          }
          if (values.releaseType == 4) {
            params.releaseDay = moment(values.releaseDate).format('MM-DD');
          }
          if (values.publishType == 4) {
            params.publishDay = moment(values.publishDate).format('MM-DD');
          }
          saveRateRules(params).then(res => {
            if (res.success) {
              this.visible = false;
              this.initList();
              this.onClearSelected();
            } else {
              this.$message.error(res.success);
            }
          });
        }
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
    },
    handleDelete(id) {
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function() {
          that.loading = true;
          let formData = new FormData();
          formData.append('id', id);
          postTag(that.delete, formData).then(res => {
            that.loading = false;
            if (res.success) {
              that.$message.success(res.message);
              that.initList();
              that.onClearSelected();
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    },
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function() {
          that.loading = true;
          let formData = new FormData();
          formData.append('ids', that.selectedRowKeys.join(','));
          postTag(that.deleteBatch, formData).then(res => {
            if (res.success) {
              that.loading = false;
              that.$message.success(res.message);
              that.initList();
              that.onClearSelected();
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    }
  }
};
</script>
<style scoped></style>
